// modules
const definitions = "definitions"
const hr = "hr"
const purchasing = "purchase"
const marketing = "marketing"
const production = "productionTitle"
const financeReport = "financeReport"

export const dashboardPagesMenu = {
	dashboard: {
		id: "dashboard",
		text: "main",
		path: "/",
		icon: "Dashboard",
		subMenu: null,
	},
};

export const companyPagesMenu = {
	name: {
		id: "admin",
		text: "admin",
		icon: "Extension",
	},
	company: {
		id: "company",
		text: "company",
		path: "company/details",
		icon: "HomeWork",
	},
	people: {
		id: "people",
		text: "people&user",
		path: "company/people",
		icon: "People",
		subMenu: {
			positions: {
				id: "positions",
				text: "positions",
				path: "company/positions",
				icon: "Layers",
			},
			people: {
				id: "people",
				text: "people",
				path: "company/people",
				icon: "Person",
			},
			users: {
				id: "users",
				text: "users",
				path: "company/users",
				icon: "PersonAddAlt",
			},
		}
	},
	departments: {
		id: "departments",
		text: "departments",
		path: "company/departments",
		icon: "Dashboard",
	},
};

export const componentPagesMenu = {
	name: {
		id: "Tanımlar",
		text: definitions,
		icon: "Extension",
		block: ["measures", "departments", "components", "raw", "operations", "product", "service"]
	},
	componentUnits: {
		id: "componentUnits",
		text: "measures",
		icon: "Architecture",
		path: "/definitions/measures",
		master: [definitions],
		block: []
	},
	componentDepartments: {
		id: "componentDepartments",
		text: "departments",
		icon: "Dashboard",
		path: "/definitions/departments",
		master: [definitions],
		block: []
	},
	components: {
		id: "components",
		text: "components",
		icon: "Source",
		path: "/definitions/components",
		master: [definitions],
		block: ["raw", "operations", "product", "service"],
		subMenu: {
			componentRawMaterials: {
				id: "componentRawMaterials",
				text: "raw",
				icon: "Dns",
				path: "/definitions/raw",
				master: [definitions, "components"]
			},
			componentOperation: {
				id: "componentOperation",
				text: "operations",
				icon: "Settings",
				path: "/definitions/operations",
				master: [definitions, "components"]

			},
			componentProduct: {
				id: "componentProduct",
				text: "product",
				icon: "Verified",
				path: "/definitions/products",
				master: [definitions, "components"]

			},
			componentService: {
				id: "componentService",
				text: "service",
				icon: "Engineering",
				path: "/definitions/services",
				master: [definitions, "components"]

			},
		}
	},
}

export const hrPagesMenu = {
	hr: {
		id: "hr",
		text: hr,
		icon: "Extension",
		block: [
			"hiring", "emptyPositions", "hiringProcesses", "cvSource", "staff", "hrPositions", "employee", "compensation", "leaves",
			"improvement", "hrPerformance", "staffRelations", "compensationAndRights", "firing",
			"jobSecurity", "culture&relations"
		],
	},
	hrPositions: {
		id: "hrPositions",
		text: "hiring",
		icon: "People",
		path: "/hr/hiring",
		master: [hr],
		block: ["emptyPositions", "hiringProcesses", "cvSource"],
		subMenu: {
			hrPositions: {
				id: "hrPozisyonlar",
				text: "emptyPositions",
				icon: "PersonAddAlt",
				path: "/hr/empty-positions",
				master: [hr, "hiring"],
			},
			hrPeriods: {
				id: "hrPeriods",
				text: "hiringProcesses",
				icon: "AccessTime",
				path: "/hr/hiring-processes",
				master: [hr, "hiring"],
			},
			hrSource: {
				id: "hrSource",
				text: "cvSource",
				icon: "Groups",
				path: "/hr/cv-source",
				master: [hr, "hiring"],
			},
		}
	},
	hrEmployee: {
		id: "hrEmployee",
		text: "staff",
		icon: "AccountCircle",
		path: "/hr/staff",
		master: [hr],
		block: ["hrPositions", "employee", "compensation", "leaves"],
		subMenu: {
			hrPositions: {
				id: "hrPozisyonlar",
				text: "hrPositions",
				icon: "Layers",
				path: "/hr/positions",
				master: [hr, "staff"],
			},
			list: {
				id: "hrEmployeeList",
				text: "employee",
				icon: "RecentActors",
				path: "/hr/employee",
				master: [hr, "staff"],
			},
			salary: {
				id: "salary",
				text: "compensation",
				icon: "Payments",
				path: "/hr/compensation",
				master: [hr, "staff"],
			},
			annualLeave: {
				id: "annualLeave",
				text: "leaves",
				icon: "PersonRemove",
				path: "/hr/leaves",
				master: [hr, "staff"],

			},
		}
	},
	hrImprovement: {
		id: "hrImprovement",
		text: "improvement",
		icon: "Timeline",
		path: "/hr/management",
		master: [hr],
		block: ["hrPerformance", "staffRelations", "compensationAndRights", "firing", "jobSecurity", "culture&relations"],
		subMenu: {
			hrPerformance: {
				id: "hrPerformans",
				text: "hrPerformance",
				icon: "Assessment",
				path: "/hr/performance",
				master: [hr, "improvement"],
			},
			hrEmployeeRelations: {
				id: "hrEmployeeRelations",
				text: "staffRelations",
				icon: "AddReaction",
				path: "/hr/staff-relations",
				master: [hr, "improvement"],
			},
			hrPrice: {
				id: "hrPrice",
				text: "compensationAndRights",
				icon: "Payments",
				path: "/hr/compensations-rights",
				master: [hr, "improvement"],
			},
			hrOff: {
				id: "hrOff",
				text: "firing",
				icon: "PersonOff",
				path: "/hr/firing",
				master: [hr, "improvement"],
			},
		}
	},
}

export const financeReportPageMenues = {
	financeReport: {
		id: financeReport,
		text: financeReport,
		icon: "AttachMoney",
		block: ["accounts", "transactions", "accounts2", "monthlyBalance", "general", "income", "outcome"]
	},
	accounts: {
		id: "accounts",
		text: "accounts",
		icon: "AccountBalanceWallet",
		path: "/finance-report/stats",
		master: [financeReport],
		block: ["transactions", "accounts2"],
		subMenu: {
			transactions: {
				id: "transactions",
				text: "transactions",
				icon: "AttachMoney",
				path: "/finance-report/transactions",
				master: [financeReport, "accounts"],
			},
			accounts: {
				id: "accounts2",
				text: "accounts2",
				icon: "AccountBalanceWallet",
				path: "/finance-report/accounts",
				master: [financeReport, "accounts"],
			}
		}
	},
	monthlyBalance: {
		id: "monthlyBalance",
		text: "monthlyBalance",
		icon: "EditCalendar",
		path: "/finance-report/stats",
		master: [financeReport],
		block: ["general", "income", "outcome"],
		subMenu: {
			general: {
				id: "general",
				text: "general",
				icon: "Analytics",
				path: "/finance-report/general",
				master: [financeReport, "monthlyBalance"],
			},
			income: {
				id: "income",
				text: "income",
				icon: "ArrowCircleDown",
				path: "/finance-report/income",
				master: [financeReport, "monthlyBalance"],
			},
			outcome: {
				id: "outcome",
				text: "outcome",
				icon: "ArrowCircleUp",
				path: "/finance-report/outcome",
				master: [financeReport, "monthlyBalance"],
			},
		}
	},
};

export const marketingPagesMenu = {
	marketing: {
		id: "marketing",
		text: marketing,
		icon: "Extension",
		block: ["audience", "audienceCategories", "audience", "audiencePlanning", "pricing", "pricingComponents", "currentPrice", "competitorAnalysis", "campaigns", "campaignTypes", "activeCampaigns", "campaignReports", "offers", "sales", "afterSales"]
	},
	marketingAudience: {
		id: "marketingAudience",
		text: "audience",
		icon: "Badge",
		path: "/marketing/companies",
		master: [marketing],
		block: ["audienceCategories", "audience", "audiencePlanning"],
		subMenu: {
			audienceCategories: {
				id: "audienceCategories",
				text: "audienceCategories",
				icon: "Layers",
				path: "/marketing/audience-categories",
				master: [marketing, "audience"],
			},
			audienceGropus: {
				id: "audienceGropus",
				text: "audience",
				icon: "People",
				path: "/marketing/audience",
				master: [marketing, "audience"],
			},
			audiencePlans: {
				id: "audiencePlans",
				text: "audiencePlanning",
				icon: "Info",
				path: "/marketing/audience-planing",
				master: [marketing, "audience"],
			},
		}
	},
	marketingPricing: {
		id: "marketingPricing",
		text: "pricing",
		icon: "BarChart",
		path: "/marketing/performance",
		master: [marketing],
		block: ["pricingComponents", "currentPrice", "competitorAnalysis"],
		subMenu: {
			pricingComponents: {
				id: "pricingComponents",
				text: "pricingComponents",
				icon: "Layers",
				path: "/marketing/price-components",
				master: [marketing, "pricing"],
			},
			actualPricing: {
				id: "actualPricing",
				text: "currentPrice",
				icon: "People",
				path: "/marketing/current-price",
				master: [marketing, "pricing"],
			},
			// pricingCompetition: {
			// 	id: "pricingCompetition",
			// 	text: "competitorAnalysis",
			// 	icon: "Info",
			// 	path: "/marketing/competitor-analysis",
			// 	master: [marketing, "pricing"],
			// },
		}
	},
	// marketingCampaingns: {
	// 	id: "marketingCampaingns",
	// 	text: "campaigns",
	// 	icon: "Campaign",
	// 	path: "/marketing/campaigns",
	// 	master: [marketing],
	// 	block: ["campaignTypes", "activeCampaigns", "campaignReports"],
	// 	subMenu : {
	// 		campaignTypes: {
	// 			id: "campaignTypes",
	// 			text: "campaignTypes",
	// 			icon: "Layers",
	// 			path: "/marketing/campaign-types",
	// 			master: [marketing, "campaigns"],
	// 		},
	// 		activeCampaigns: {
	// 			id: "activeCampaigns",
	// 			text: "activeCampaigns",
	// 			icon: "Campaign",
	// 			path: "/marketing/active-campaigns",
	// 			master: [marketing, "campaigns"],
	// 		},
	// 		campaignReports: {
	// 			id: "campaignReports",
	// 			text: "campaignReports",
	// 			icon: "Info",
	// 			path: "/marketing/campaign-reports",
	// 			master: [marketing, "campaigns"],
	// 		},
	// 	}
	// },
	marketingOffers: {
		id: "marketingOffers",
		text: "offers",
		icon: "Article",
		path: "/marketing/offers",
		master: [marketing],
		block: [""],
	},
	marketingSales: {
		id: "marketingSales",
		text: "sales",
		icon: "BusinessCenter",
		path: "/marketing/sales",
		master: [marketing],
		block: []
	},
	marketingService: {
		id: "marketingService",
		text: "afterSales",
		icon: "HomeRepairService",
		path: "/marketing/performance",
		master: [marketing],
		block: []
	},
}

export const costPagesMenu = {
	marketingOffers: {
		id: "marketingOffers",
		text: "offers",
		icon: "Article",
		path: "/marketing/offers",
		master: [marketing],
		block: [""],
	},
	marketingSales: {
		id: "marketingSales",
		text: "sales",
		icon: "BusinessCenter",
		path: "/marketing/sales",
		master: [marketing],
		block: []
	},
	marketingService: {
		id: "marketingService",
		text: "afterSales",
		icon: "HomeRepairService",
		path: "/marketing/performance",
		master: [marketing],
		block: []
	},
}

export const purchasingPagesMenu = {
	purchasing: {
		id: "purchasing",
		text: purchasing,
		icon: "Extension",
		block: ["companies", "supply", "demands", "purchaseProcesses", "plannedPurchase", "aggrements", "delivery", "costControl", "improvements", "policies", "inventory", "supplierPool"]
	},
	purchaseCompanies: {
		id: "purchaseCompanies",
		text: "companies",
		icon: "BusinessCenter",
		path: "/purchase/companies",
		master: [purchasing],
		block: []
	},
	purchasingDemands: {
		id: "purchasingDemands",
		text: "supply",
		icon: "LocalShipping",
		path: "/purchase/supply",
		master: [purchasing],
		block: ["demands", "purchaseProcesses", "plannedPurchase", "aggrements", "delivery"],
		subMenu: {
			// purchaseDemands: {
			// 	id: "purchaseDemands",
			// 	text: "demands",
			// 	icon: "Info",
			// 	path: "/purchase/demands",
			// 	master: [purchasing, "supply"],
			// },
			purchasingPeriods: {
				id: "purchasingPeriods",
				text: "purchaseProcesses",
				icon: "AccessTime",
				path: "/purchase/processes",
				master: [purchasing, "supply"],
			},
			purchasePlans: {
				id: "purchasePlans",
				text: "plannedPurchase",
				icon: "Checklist",
				path: "/purchase/purchase-plan",
				master: [purchasing, "supply"],
			},
			purchaseAgreement: {
				id: "purchaseAgreement",
				text: "aggrements",
				icon: "Article",
				path: "/purchase/aggrements",
				master: [purchasing, "supply"],
			},
			purchaseWaybills: {
				id: "purchaseWaybills",
				text: "delivery",
				icon: "LocalShipping",
				path: "/purchase/delivery",
				master: [purchasing, "supply"],
			},
		}
	},
	purchasePriceControl: {
		id: "purchasePriceControl",
		text: "costControl",
		icon: "Article",
		path: "/purchase/price-control",
		master: [purchasing],
		block: []
	},
	// purchaseImprovements: {
	// 	id: "purchaseImprovements",
	// 	text: "improvements",
	// 	icon: "Timeline",
	// 	path: "/purchase/price-control",
	// 	master: [purchasing],
	// 	block: ["policies", "inventory", "supplierPool"],
	// 	subMenu: {
	// 		purchasePolicies: {
	// 			id: "purchasePolicies",
	// 			text: "policies",
	// 			icon: "Ballot",
	// 			path: "/purchase/policies",
	// 			master: [purchasing, "improvements"],
	// 		},
	// 		purchaseStockRow: {
	// 			id: "purchaseStockRow",
	// 			text: "inventory",
	// 			icon: "AutoAwesomeMosaic",
	// 			path: "/purchase/stock-inventory",
	// 			master: [purchasing, "improvements"],
	// 		},
	// 		purchaseNet: {
	// 			id: "purchaseNet",
	// 			text: "supplierPool",
	// 			icon: "BusinessCenter",
	// 			path: "/purchase/supply-pool",
	// 			master: [purchasing, "improvements"],
	// 		},
	// 	}
	// },
}

export const productionPagesMenu = {
	productionStock: {
		id: "productionStock",
		text: production,
		icon: "Extension",
		block: ["projects", "transactionLogs", "allPlannedProduction", "allProjects", "allRecords", "activeProjects", "projectExpenses", "teams", "projectReports", "projectArchive", "production", "workOrders", "allProductionWorkPlanned", "plannedProduction", "productionReports", "archive", "stock", "waybills", "rawStock", "productStock",]
	},
	// productionWorkBills: {
	// 	id: "productionWorkBills",
	// 	text: "workOrders",
	// 	icon: "ReceiptLong",
	// 	path: "/production/is-emirleri",
	// 	master: [production, "production"],
	// },
	allRecords: {
		id: "allRecords",
		text: "allRecords",
		icon: "Description",
		path: "/production/all-transaction-logs",
		master: [production, "production"],
	},
	productionRecords: {
		id: "productionRecords",
		text: "transactionLogs",
		icon: "Description",
		path: "/production/transaction-logs",
		master: [production, "production"],
	},
	// projectTeams: {
	// 	id: "projectTeams",
	// 	text: "teams",
	// 	icon: "GroupWork",
	// 	path: "/project/teams",
	// 	master: [production, "production"],
	// },
	projects: {
		id: "projects",
		text: "projects",
		icon: "Workspaces",
		path: "/project",
		block: ["projects", "allProjects", "projectExpenses", "activeProjects", "projectReports", "projectArchive"],
		master: [production],
		subMenu: {
			allProjects: {
				id: "allProjects",
				text: "allProjects",
				icon: "Workspaces",
				path: "/project/all-projects",
				master: [production, "projects"],
			},
			activeProjects: {
				id: "activeProjects",
				text: "activeProjects",
				icon: "Workspaces",
				path: "/project/active-projects",
				master: [production, "projects"],
			},
			projectExpenses: {
				id: "projectExpenses",
				text: "projectExpenses",
				icon: "AttachMoney",
				path: "/project/projects-expenses",
				master: [production, "projects"],
			},
			projectReports: {
				id: "projectReports",
				text: "projectReports",
				icon: "Description",
				path: "/project/reports",
				master: [production, "projects"],
			},
			projectArchive: {
				id: "projectArchive",
				text: "projectArchive",
				icon: "Archive",
				path: "/project/archive",
				master: [production, "projects"],
			},
		}
	},
	production: {
		id: "production",
		text: "production",
		icon: "Verified",
		path: "/production",
		master: [production],
		block: ["workOrders", "allProductionWorkPlanned", "plannedProduction", "productionReports", "archive",],
		subMenu: {
			allProductionWorkPlanned: {
				id: "allProductionWorkPlanned",
				text: "allPlannedProduction",
				icon: "AccessTime",
				path: "/production/allplanned",
				master: [production, "production"],
			},
			productionWorkPlanned: {
				id: "productionWorkPlanned",
				text: "plannedProduction",
				icon: "AccessTime",
				path: "/production/planned",
				master: [production, "production"],
			},
			productionReports: {
				id: "productionReports",
				text: "productionReports",
				icon: "Description",
				path: "/production/reports",
				master: [production, "production"],
			},
			productionArchive: {
				id: "productionArchive",
				text: "archive",
				icon: "Archive",
				path: "/production/archive",
				master: [production, "production"],
			},
		}
	},
	stock: {
		id: "stock",
		text: "stock",
		icon: "AutoAwesomeMosaic",
		path: "/stock",
		master: [production],
		block: ["waybills", "rawStock", "productStock"],
		subMenu: {
			stockWaybills: {
				id: "stockWaybills",
				text: "waybills",
				icon: "Receipt",
				path: "/stock/waybills",
				master: [production, "stock"],
			},
			stockRaw: {
				id: "stockRaw",
				text: "rawStock",
				icon: "Dns",
				path: "/stock/raw",
				master: [production, "stock"],
			},
			stockProduct: {
				id: "stockProduct",
				text: "productStock",
				icon: "Verified",
				path: "/stock/product",
				master: [production, "stock"],
			},
		}
	},
}

export const demoPagesMenu = {
	auth: {
		id: "auth",
		text: "Auth Pages",
		icon: "Extension",
	},
	login: {
		id: "login",
		text: "login",
		path: "auth/login",
		icon: "Login",
	},
	signUp: {
		id: "signUp",
		text: "signUp",
		path: "auth/sign-up",
		icon: "PersonAdd",
	},
	page404: {
		id: "Page404",
		text: "404",
		path: "auth/404",
		icon: "ReportGmailerrorred",
	},
};

export const myPages = {
	department: {
		id: "departman",
		text: "department",
		path: "/dashboard/departments",
		icon: "Dashboard",
		isPublic: true
	},
	projects: {
		id: "proje",
		text: "projects",
		path: "/dashboard/projects",
		icon: "Workspaces",
		isPublic: true
	},
	production: {
		id: "production",
		text: "production",
		path: "/dashboard/production",
		icon: "Verified",
		isPublic: true
	},
	tasks: {
		id: "tasks",
		text: "tasks",
		path: "/dashboard/tasks",
		icon: "Task",
		isPublic: true
	},
};

export const pageMenues = {
	department: {
		id: "department",
		text: "department",
		subMenu: {
			general: {
				id: 'departmentGeneral',
				text: 'general',
				path: 'definitions/departments/department-detail',
				icon: 'Info',
				isPublic: true
			},
			subUnits: {
				id: 'departmentSubUnits',
				text: 'subUnits',
				path: 'definitions/departments/department-detail/subunits',
				icon: 'Dashboard',
				isPublic: true
			},
			people: {
				id: 'departmentPeople',
				text: 'people',
				path: 'definitions/departments/department-detail/people',
				icon: 'People',
				isPublic: true
			},
			operations: {
				id: 'departmentOperations',
				text: 'operations',
				path: 'definitions/departments/department-detail/operations',
				icon: 'Settings',
				isPublic: true
			},
			gallery: {
				id: 'departmentGallery',
				text: 'gallery',
				path: 'definitions/departments/department-detail/gallery',
				icon: 'PhotoLibrary',
				isPublic: true
			},
			tutorial: {
				id: 'departmentTutorial',
				text: 'documentation',
				path: 'definitions/departments/department-detail/orientation',
				icon: 'MenuBook',
				isPublic: true
			},
		}
	},
	product: {
		id: "department",
		text: "Ürünler",
		subMenu: {
			general: {
				id: 'productGeneral',
				text: 'general',
				path: 'definitions/products/product-detail',
				icon: 'Info',
				isPublic: true
			},
			productRaws: {
				id: 'productRaws',
				text: 'raws',
				path: 'definitions/products/product-detail/raws',
				icon: 'Dns',
				isPublic: true
			},
			semiProducts: {
				id: 'productSemiProducts',
				text: 'semiproducts',
				path: 'definitions/products/product-detail/semiproducts',
				icon: 'Verified',
				isPublic: true
			},
			productOperations: {
				id: 'productOperations',
				text: 'operations',
				path: 'definitions/products/product-detail/operations',
				icon: 'Settings',
				isPublic: true
			},
			gallery: {
				id: 'productGallery',
				text: 'gallery',
				path: 'definitions/products/product-detail/gallery',
				icon: 'PhotoLibrary',
				isPublic: true
			},
		}
	},
	service: {
		id: "department",
		text: "Hizmet",
		subMenu: {
			general: {
				id: 'productGeneral',
				text: 'general',
				path: 'definitions/services/service-detail',
				icon: 'Info',
				isPublic: true
			},
			productRaws: {
				id: 'productRaws',
				text: 'raws',
				path: 'definitions/services/service-detail/raws',
				icon: 'Dns',
				isPublic: true
			},
			semiProducts: {
				id: 'productSemiProducts',
				text: 'semiproducts',
				path: 'definitions/services/service-detail/semiproducts',
				icon: 'Verified',
				isPublic: true
			},
			productOperations: {
				id: 'productOperations',
				text: 'operations',
				path: 'definitions/services/service-detail/operations',
				icon: 'Settings',
				isPublic: true
			},
			gallery: {
				id: 'productGallery',
				text: 'gallery',
				path: 'definitions/services/service-detail/gallery',
				icon: 'PhotoLibrary',
				isPublic: true
			},
		}
	},
}

export const projectPagesMenu = {
	general: {
		id: "general",
		text: "general",
		path: "/project/all-projects/project-detail",
		icon: "Info",
		isPublic: true
	},
	subProjects: {
		id: "subProjects",
		text: "subProjects",
		path: "/project/all-projects/sub-project",
		icon: "SubdirectoryArrowRight",
		isPublic: true
	},
	cashFlow: {
		id: "cashFlow",
		text: "cashFlow",
		path: "/project/all-projects/project-cash-flow",
		icon: "AccountBalanceWallet",
		isPublic: true
	},
	columns: {
		id: "columns",
		text: "steps",
		path: "/project/all-projects/project-steps",
		icon: "ViewColumn",
		isPublic: true
	},
	inputs: {
		id: "inputs",
		text: "inputs",
		path: "/project/all-projects/project-inputs",
		icon: "Dashboard",
		isPublic: true
	},
	outputs: {
		id: "outputs",
		text: "outputs",
		path: "/project/all-projects/project-outputs",
		icon: "Verified",
		isPublic: true
	},
	flow: {
		id: "columns",
		text: "flow",
		path: "/project/all-projects/flow",
		icon: "DragIndicator",
		isPublic: true
	},
	gantt: {
		id: "columns",
		text: "gantt",
		path: "/project/all-projects/gantt",
		icon: "Schema",
		isPublic: true
	},
	files: {
		id: "files",
		text: "files",
		path: "/project/all-projects/project-files",
		icon: "FileCopy",
		isPublic: true
	},
};

export const subProjectPagesMenu = {
	general: {
		id: "general",
		text: "general",
		path: "/project/active-projects/project-detail",
		icon: "Info",
		isPublic: true
	},
	cashFlow: {
		id: "cashFlow",
		text: "cashFlow",
		path: "/project/active-projects/project-cash-flow",
		icon: "AccountBalanceWallet",
		isPublic: true
	},
	columns: {
		id: "columns",
		text: "steps",
		path: "/project/active-projects/project-steps",
		icon: "ViewColumn",
		isPublic: true
	},
	inputs: {
		id: "inputs",
		text: "inputs",
		path: "/project/active-projects/project-inputs",
		icon: "Dashboard",
		isPublic: true
	},
	outputs: {
		id: "outputs",
		text: "outputs",
		path: "/project/active-projects/project-outputs",
		icon: "Verified",
		isPublic: true
	},
	flow: {
		id: "columns",
		text: "flow",
		path: "/project/active-projects/flow",
		icon: "DragIndicator",
		isPublic: true
	},
	gantt: {
		id: "columns",
		text: "gantt",
		path: "/project/active-projects/gantt",
		icon: "Schema",
		isPublic: true
	},
	files: {
		id: "files",
		text: "files",
		path: "/project/active-projects/project-files",
		icon: "FileCopy",
		isPublic: true
	},
};

export const hrProcessPagesMenu = {
	general: {
		id: "general",
		text: "general",
		path: "/hr/hiring-processes/process-detail",
		icon: "Info",
		isPublic: true
	},
	columns: {
		id: "columns",
		text: "steps",
		path: "/hr/hiring-processes/process-steps",
		icon: "ViewColumn",
		isPublic: true
	},
	files: {
		id: "files",
		text: "files",
		path: "/hr/hiring-processes/process-files",
		icon: "FileCopy",
		isPublic: true
	},
};

export const purchasePagesMenu = {
	general: {
		id: "general",
		text: "general",
		path: "/purchase/processes/process-detail",
		icon: "Info",
		isPublic: true
	},
	columns: {
		id: "columns",
		text: "steps",
		path: "/purchase/processes/process-steps",
		icon: "ViewColumn",
		isPublic: true
	},
	inputs: {
		id: "inputs",
		text: "materials",
		path: "/purchase/processes/process-materials",
		icon: "Dashboard",
		isPublic: true
	},
	planned: {
		id: "inputs",
		text: "planned",
		path: "/purchase/processes/process-planned",
		icon: "AccessTime",
		isPublic: true
	},
	files: {
		id: "files",
		text: "files",
		path: "/purchase/processes/process-files",
		icon: "FileCopy",
		isPublic: true
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: "layoutTypes",
		text: "Page Layout Types",
	},
	blank: {
		id: "blank",
		text: "Blank",
		path: "page-layouts/blank",
		icon: "check_box_outline_blank ",
	},
	pageLayout: {
		id: "pageLayout",
		text: "Page Layout",
		path: "page-layouts",
		icon: "BackupTable",
		subMenu: {
			headerAndSubheader: {
				id: "headerAndSubheader",
				text: "Header & Subheader",
				path: "page-layouts/header-and-subheader",
				icon: "ViewAgenda",
			},
			onlyHeader: {
				id: "onlyHeader",
				text: "Only Header",
				path: "page-layouts/only-header",
				icon: "ViewStream",
			},
			onlySubheader: {
				id: "onlySubheader",
				text: "Only Subheader",
				path: "page-layouts/only-subheader",
				icon: "ViewStream",
			},
			onlyContent: {
				id: "onlyContent",
				text: "Only Content",
				path: "page-layouts/only-content",
				icon: "WebAsset",
			},
		},
	},
	asideTypes: {
		id: "asideTypes",
		text: "Aside Types",
		path: "aside-types",
		icon: "Vertical Split",
		subMenu: {
			defaultAside: {
				id: "defaultAside",
				text: "Default Aside",
				path: "aside-types/default-aside",
				icon: "ViewQuilt",
			},
			minimizeAside: {
				id: "minimizeAside",
				text: "Minimize Aside",
				path: "aside-types/minimize-aside",
				icon: "View Compact",
			},
		},
	},
};

export const summaryPageTopMenu = {
	intro: { id: "intro", text: "Intro", path: "#intro", icon: "Vrpano", subMenu: null },
	bootstrap: {
		id: "bootstrap",
		text: "Bootstrap Components",
		path: "#bootstrap",
		icon: "BootstrapFill",
		subMenu: null,
	},
	storybook: {
		id: "storybook",
		text: "Storybook",
		path: "#storybook",
		icon: "CustomStorybook",
		subMenu: null,
	},
	formik: {
		id: "formik",
		text: "Formik",
		path: "#formik",
		icon: "CheckBox",
		subMenu: null,
	},
	apex: {
		id: "apex",
		text: "Apex Charts",
		path: "#apex",
		icon: "AreaChart",
		subMenu: null,
	},
};

export const productsExampleMenu = {
	companyA: { id: "companyA", text: "Company A", path: "grid-pages/products", subMenu: null },
	companyB: { id: "companyB", text: "Company B", path: "/", subMenu: null },
	companyC: { id: "companyC", text: "Company C", path: "/", subMenu: null },
	companyD: { id: "companyD", text: "Company D", path: "/", subMenu: null },
};
